import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import { getAuthorisationHeader } from "../utils/identity";

const getRequestProperties = ({ authorisationHeader }) => {
  const { recsApiTimeout, recommendedOutfitsApiUrl } = getRuntimeConstants();

  return {
    url: recommendedOutfitsApiUrl,
    timeout: recsApiTimeout,
    headers: {
      authorization: authorisationHeader,
      "asos-c-recs-scope": "pdp-outfit",
    },
  };
};

export default async function getRecommendedOutfits({ product }) {
  if (!product?.id) {
    return [];
  }

  const {
    webContext: {
      browseCountry,
      browseCurrency,
      browseLanguage,
      keyStoreDataversion,
      storeId,
    },
  } = getRuntimeConstants();

  const authorisationHeader = await getAuthorisationHeader();

  const params = {
    expand: "products",
    store: storeId,
    country: browseCountry,
    currency: browseCurrency,
    lang: browseLanguage,
    productId: product.id,
    keyStoreDataversion,
  };

  return makeRequest({
    params,
    ...getRequestProperties({ authorisationHeader }),
    handleErrorReturnValue: () => [],
  });
}
